import SimpleBar from 'simplebar-react';
import React from 'react';
import 'simplebar/dist/simplebar.css';
import { StyledSimpleBar } from './styles';

export type ScrollableContainerChildrenProps = SimpleBar.ChildrenProps;
export type ScrollableContainerProps = SimpleBar.Props & {
  className?: string;
  children?: React.ReactNode | ((props: ScrollableContainerChildrenProps) => React.ReactNode);
};

export default function ScrollableContainer({
  className,
  children,
  ...otherProps
}: ScrollableContainerProps): JSX.Element {
  return (
    <StyledSimpleBar
      className={className}
      {...otherProps}
    >
      {children}
    </StyledSimpleBar>
  );
}
